// extracted by mini-css-extract-plugin
export default {"FieldGroup":"otp_FieldGroup__NIL-q","Digit":"otp_Digit__UPG+6","Status":"otp_Status__+ws9t","Error":"otp_Error__4RYzs","Resend":"otp_Resend__wpCRU","Footer":"otp_Footer__Y23cS"};